import { render, staticRenderFns } from "./shareMobile.vue?vue&type=template&id=766fa7ba&scoped=true&"
import script from "./shareMobile.vue?vue&type=script&lang=js&"
export * from "./shareMobile.vue?vue&type=script&lang=js&"
import style0 from "./shareMobile.vue?vue&type=style&index=0&id=766fa7ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766fa7ba",
  null
  
)

export default component.exports